import React from 'react';
import { Navbar } from './components/Navbar';
import { Hero } from './components/Hero';
import { StatsBar } from './components/StatsBar';
import { Problem } from './components/Problem';
import { Solution } from './components/Solution';
import { Included } from './components/Included';
import { Modules } from './components/Modules';
import { Bonuses } from './components/Bonuses';
import { Benefits } from './components/Benefits';
import { Audience } from './components/Audience';
import { Testimonials } from './components/Testimonials';
import { Guarantee } from './components/Guarantee';
import { Offer } from './components/Offer';
import { FAQ } from './components/FAQ';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
export function App() {
  return <div className="min-h-screen bg-legal-900 text-slate-50 font-sans selection:bg-gold-500/30" data-id="element-0">
      <Navbar data-id="element-1" />
      <main data-id="element-2">
        <Hero data-id="element-3" />
        <StatsBar data-id="element-4" />
        <Problem data-id="element-5" />
        <Solution data-id="element-6" />
        <Included data-id="element-7" />
        <Modules data-id="element-8" />
        <Bonuses data-id="element-9" />
        <Benefits data-id="element-10" />
        <Audience data-id="element-11" />
        <Testimonials data-id="element-12" />
        <Guarantee data-id="element-13" />
        <Offer data-id="element-14" />
        <FAQ data-id="element-15" />
        <FinalCTA data-id="element-16" />
      </main>
      <Footer data-id="element-17" />
    </div>;
}